import { NgModule } from '@angular/core';
import { EgButtonComponent } from './components/eg-button/eg-button.component';
import { EgInputComponent } from './components/eg-input/eg-input.component';
import { EgDropdownComponent } from './components/eg-dropdown/eg-dropdown.component';
import { EgCheckboxComponent } from './components/eg-checkbox/eg-checkbox.component';
import { EgRadioButtonComponent } from './components/eg-radio-button/eg-radio-button.component';
import { EgTextareaComponent } from './components/eg-textarea/eg-textarea.component';
import { EgFormComponent } from './components/eg-form/eg-form.component';
import { EgDatepickerComponent } from './components/eg-datepicker/eg-datepicker.component';

@NgModule({
  imports: [
    EgInputComponent,
    EgButtonComponent,
    EgDropdownComponent,
    EgCheckboxComponent,
    EgRadioButtonComponent,
    EgTextareaComponent,
    EgFormComponent,
    EgDatepickerComponent
  ],
  exports: [
    EgInputComponent,
    EgButtonComponent,
    EgDropdownComponent,
    EgCheckboxComponent,
    EgRadioButtonComponent,
    EgTextareaComponent,
    EgFormComponent,
    EgDatepickerComponent
  ],
})
export class SharedModule {}
